export const BILL_FILE_MAX_BYTES = 10 * 1024 * 1024;

const ALLOWED_MIME_TYPES = new Set([
  "application/pdf",
  "image/jpeg",
  "image/png",
]);

const ALLOWED_EXTENSIONS = new Set(["pdf", "jpg", "jpeg", "png"]);

export function resolveBillFileMimeType(file: File): string {
  const mime = file.type.trim().toLowerCase();
  if (ALLOWED_MIME_TYPES.has(mime)) {
    return mime;
  }

  if (mime.startsWith("image/")) {
    return mime;
  }

  const ext = file.name.split(".").pop()?.toLowerCase();
  if (ext === "png") return "image/png";
  if (ext === "jpg" || ext === "jpeg") return "image/jpeg";
  if (ext === "pdf") return "application/pdf";

  return "application/pdf";
}

export function validateBillFile(file: File): string | null {
  if (file.size > BILL_FILE_MAX_BYTES) {
    return "File is too large. Maximum size is 10MB.";
  }

  const mime = file.type.trim().toLowerCase();
  const ext = file.name.includes(".") ? file.name.split(".").pop()?.toLowerCase() : undefined;

  const mimeAllowed = mime && (ALLOWED_MIME_TYPES.has(mime) || mime.startsWith("image/"));
  const extAllowed = ext ? ALLOWED_EXTENSIONS.has(ext) : false;

  if (!mimeAllowed && !extAllowed) {
    return "Unsupported file type. Please upload a PDF, JPG, or PNG.";
  }

  return null;
}

export function normalizeBillFile(file: File): File {
  const name = file.name.trim();
  const ext = name.includes(".") ? name.split(".").pop()?.toLowerCase() : undefined;
  const hasValidExtension = ext ? ALLOWED_EXTENSIONS.has(ext) : false;

  if (name && hasValidExtension) {
    return file;
  }

  const mime = resolveBillFileMimeType(file);
  const extension = mime === "image/png" ? "png" : mime === "image/jpeg" ? "jpg" : "pdf";

  return new File([file], `bill-photo.${extension}`, {
    type: mime || file.type,
    lastModified: file.lastModified,
  });
}

export function prepareBillFile(file: File): { file: File; error: string | null } {
  const normalized = normalizeBillFile(file);
  const error = validateBillFile(normalized);
  return { file: normalized, error };
}
